export default function (Upload, authorizationToken, toaster) {
    return function (importTypeId, files) {
        const url = `/api/importfile/${importTypeId}`;

        return files.map(x => uploadImport(url, x));
    };

    function uploadImport(url, file) {
        file.status = 'Uploading';
        file.progress = 0;

        return Upload.http({
                url,
                headers: {
                    'Content-Type': file.type || "text/plain",
                    'Content-Disposition': `attachment;filename="${encodeURI(file.name)}"`,
                    'Authorization': authorizationToken
                },
                data: file
            })
            .then(() => {
                file.status = 'Completed';
                file.progress = 100;
            }, resp => {
                file.status = 'failed';
                file.progress = 0;
                switch (resp.status) {
                    case 415:
                        toaster.pop('error', 'Contents of the file do not match the import type.  Choose another file');
                        break;
                    case 400:
                        toaster.pop('error', resp.data.message || 'Invalid file extension.  Choose another file');
                        break;
                    case 429:
                        toaster.pop('error', 'Too many requests.  Please try again later.');
                        break;
                    default:
                        toaster.pop('error', 'An unexpected error occurred.  Please try again.')
                        break;
                }
            }, evt => {
                file.progress = getPercentage(evt.loaded, evt.total);
            });
    }

    function getPercentage(progress, total) {
        return 100 * parseInt(progress, 10) / parseInt(total, 10);
    }
}


// WEBPACK FOOTER //
// ./Client/app/data-import-export/services/upload/uploadImports.js